import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { opShareLast } from './../../utils';

/* Copyright IBM Corp. 2017 */
const DEFAULT_PUBLIC_URL = true;
const BFF_PUBLIC_URL = 'delivery/v1/rendering/';
const BFF_SECURE_URL = 'mydelivery/v1/rendering/';

// trigger to decide whether or not to use public URLs
export const USE_PUBLIC_URL = new BehaviorSubject<boolean>(DEFAULT_PUBLIC_URL);

/** observable that exposes the current base URL for the BFF. The URL does NOT start with
 * a slash but ends with a slash */
export const BFF_BASE_URL: Observable<string> = USE_PUBLIC_URL.pipe(
    map<boolean, string>(bFlag => bFlag ? BFF_PUBLIC_URL : BFF_SECURE_URL),
    distinctUntilChanged<string>(),
    opShareLast
);
